export const liveChatCoreStyles = `

.liveChat-widget * {
  font-weight: 500;
}

.liveChat-launcher {
  position: fixed;
  z-index: var(--z-modal);
}

.liveChat-launcher-right {
  bottom: var(--liveChat-v-padding, var(--spacing-5));
  right: var(--liveChat-h-padding, var(--spacing-5));
}

.liveChat-launcher-left {
  bottom: var(--liveChat-v-padding, var(--spacing-5));
  left: var(--liveChat-h-padding, var(--spacing-5));
}

.liveChat-launcher-btn {
  width: 60px;
  height: 60px;
  border-radius: var(--radius-full);
  border: none;
  background: var(--color-primary);
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-lg);
  transition: all var(--transition-slow);
  position: relative;
}

.liveChat-launcher-btn:hover {
  box-shadow: var(--shadow-xl);
}

.liveChat-launcher-btn:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

.liveChat-launcher-badge {
  position: absolute;
  top: -3px;
  right: -3px;
  min-width: 22px;
  height: 22px;
  background: #ef4444;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border: 2.5px solid #ffffff;
  box-shadow: 0 2px 6px rgb(239 68 68 / 0.45);
  letter-spacing: -0.2px;
  line-height: 1;
}

.liveChat-panel {
  position: fixed;
  z-index: var(--z-popover);
  width: 400px;
  height: 720px;
  max-height: calc(100vh - 100px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(8px) scale(0.97);
  transition:
    opacity 160ms cubic-bezier(0.4, 0, 1, 1),
    transform 180ms cubic-bezier(0.4, 0, 1, 1),
    visibility 0s linear 180ms,
    width 300ms cubic-bezier(0.16, 1, 0.3, 1),
    height 300ms cubic-bezier(0.16, 1, 0.3, 1),
    max-height 300ms cubic-bezier(0.16, 1, 0.3, 1);
}

.liveChat-panel.open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0) scale(1);
  transition:
    opacity 220ms cubic-bezier(0.16, 1, 0.3, 1),
    transform 300ms cubic-bezier(0.16, 1, 0.3, 1),
    visibility 0s linear 0s;
}

.liveChat-panel-right {
  bottom: calc(var(--liveChat-v-padding, var(--spacing-5)) + 70px);
  right: var(--liveChat-h-padding, var(--spacing-5));
  transform-origin: bottom right;
}

.liveChat-panel-left {
  bottom: calc(var(--liveChat-v-padding, var(--spacing-5)) + 70px);
  left: var(--liveChat-h-padding, var(--spacing-5));
  transform-origin: bottom left;
}

.liveChat-panel-content {
  background: var(--msg-bg);
  height: 100%;
  border-radius: var(--radius-2xl);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--msg-border);
}

.liveChat-panel-content *::-webkit-scrollbar {
  display: none;
}

.liveChat-panel-content * {
  scrollbar-width: none;
}

.liveChat-panel-views {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.liveChat-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.liveChat-avatar-stack {
  display: flex;
  align-items: center;
}

.liveChat-avatar-stack .sdk-avatar {
  margin-left: -8px;
}

.liveChat-avatar-stack .sdk-avatar:first-child {
  margin-left: 0;
}

.liveChat-avatar-stack-tiny .sdk-avatar {
  margin-left: -6px;
}

.liveChat-avatar-stack-tiny .sdk-avatar:first-child {
  margin-left: 0;
}

.liveChat-mobile-close-btn {
  display: none;
}

.liveChat-panel.liveChat-panel-expanded {
  width: 720px;
  height: 88vh;
  max-height: 88vh;
}

.liveChat-chat-menu-wrapper {
  position: relative;
}

.liveChat-chat-menu-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: var(--color-white, #ffffff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  min-width: 190px;
  z-index: 20;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: opacity 140ms ease, transform 140ms ease, visibility 0s linear 140ms;
}

.liveChat-chat-menu-dropdown.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  transition: opacity 140ms ease, transform 140ms ease, visibility 0s linear 0s;
}

.liveChat-chat-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-primary, #111827);
  text-align: left;
  transition: background 120ms;
}

.liveChat-chat-menu-item:hover {
  background: var(--color-neutral-50, #f9fafb);
}

.liveChat-chat-menu-item iconify-icon {
  color: var(--color-text-secondary, #6b7280);
  flex-shrink: 0;
}

@media (max-width: 480px) {
  .liveChat-mobile-close-btn {
    display: flex;
  }
  .liveChat-chat-menu-wrapper {
    display: none;
  }
  .liveChat-panel {
    width: 100%;
    height: 100%;
    max-height: 100%;
    bottom: 0;
    right: 0;
    left: 0;
    border-radius: 0;
    transform-origin: bottom center;
    transform: translateY(12px) scale(0.98);
  }

  .liveChat-panel.open {
    transform: translateY(0) scale(1);
  }

  .liveChat-panel-content {
    border-radius: 0;
  }

  .liveChat-launcher {
    bottom: var(--spacing-4);
    right: var(--spacing-4);
  }

  .liveChat-launcher-left {
    left: var(--spacing-4);
  }
}

/* ========================================
   DARK THEME — token overrides only
   ======================================== */

.liveChat-widget.theme-dark {
  /* Web Chat semantic tokens */
  --msg-bg: #0f1317;
  --msg-bg-surface: #1a1e24;
  --msg-bg-elevated: #232930;
  --msg-bg-hover: #232930;
  --msg-bg-input: #1a1e24;
  --msg-bg-bubble-own: #1e2330;
  --msg-bg-bubble-received: #1D4ED8;
  --msg-bg-header-gradient: linear-gradient(180deg, #1a1e2e 0%, #141720 50%, #0f1317 100%);
  --msg-bg-header-glow1: radial-gradient(circle, rgba(21, 94, 239, 0.07) 0%, transparent 70%);
  --msg-bg-header-glow2: radial-gradient(circle, rgba(139, 92, 246, 0.05) 0%, transparent 70%);
  --msg-text: #e8e8e8;
  --msg-text-secondary: #999999;
  --msg-text-tertiary: #666666;
  --msg-text-muted: #555555;
  --msg-border: #232930;
  --msg-border-bubble: #3a4255;
  --msg-shadow-card: none;
  --msg-shadow-card-hover: none;

  /* Override base design tokens within web chat scope */
  --color-white: #0f1317;
  --color-background: #0f1317;
  --color-surface: #1a1e24;
  --color-neutral-50: #1a1e24;
  --color-neutral-100: #1a1e24;
  --color-neutral-200: #232930;
  --color-neutral-300: #2d343c;
  --color-neutral-400: #555555;
  --color-neutral-500: #777777;
  --color-border: #232930;
  --color-text-primary: #e8e8e8;
  --color-text-secondary: #999999;
  --color-text-tertiary: #666666;
  --color-success-light: rgba(16, 185, 129, 0.15);
  --color-success-dark: #34d399;
  --color-error: #f87171;
  --color-error-light: rgba(239, 68, 68, 0.15);
  --color-error-dark: #fca5a5;
}
`;
